import React, {useState, useEffect} from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import TableAdmin from "./components/TableAdmin";
import GroupOverview from "./components/GroupOverview";
import GroupsEdit from "./components/report_groups/GroupsEdit";
import ReportsGroupsAssignment from "./components/reports/ReportsGroupsAssignment";
import ReportOverview from "./components/ReportOverview";
import DashboardHome from "./components/DashboardHome";
import LiveDashboardWebSocket from "./components/LiveDashboardWebSocket";
import ButtonReportDefinitionsEditor from "./components/ButtonReportDefinitionsEditor";
import ReportMembersEditor from "./components/members/ReportMembersEditor";
import ReportGroupsEditor from "./components/report_groups/ReportGroupsEditor";
import ButtonPressAnalytics from "./components/ButtonPressAnalytics";
import ButtonPressTimeline from "./components/ButtonPressTimeline";
import Login from "./components/Authentication/Login";
import Logout from "./components/Authentication/Logout";


const tables = [
  "button_press_data",
  "button_report_definitions",
  "input_data",
  "last_report_times",
  "report_groups",
  "report_groups_members",
  "report_members",
  "report_report_groups"
];

export default function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  const ProtectedRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  return (
    <div className="flex h-screen">
      {isAuthenticated && (
      /* Sidebar receives dashboards and tables separately */
      <Sidebar
        dashboards={[
          { name: "Pārskats", path: "/" },
          { name: "Reāllaika dati", path: "/live-dashboard" },
          { name: "Datu analīze", path: "/analytics" },
          { name: "Laika grafiks", path: "/timeline" },
          { name: "Notikumu definīcijas", path: "/button-report-definitions" },
          { name: "Kontaktpersonas", path: "/report-members" },
          { name: "Kontaktpersonu grupas", path: "/report-groups-edit" },
          { name: "Notikumu/grupu piesaiste", path: "/reports-groups-assignment" },
          { name: "Notikumu grupu pārskats", path: "/reports-overview" },
        ]}
        tables={tables}
      />
      )}

      <div className="flex-1 p-6 overflow-auto">
        <Routes>
          <Route path="/login" element={<Login setAuth={setIsAuthenticated} />} />

          {/* Dashboard Routes */}
          <Route path="/" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
          <Route path="/live-dashboard" element={<ProtectedRoute><LiveDashboardWebSocket /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><ButtonPressAnalytics /></ProtectedRoute>} />
          <Route path="/timeline" element={<ProtectedRoute><ButtonPressTimeline /></ProtectedRoute>} />
          <Route path="/report-members" element={<ProtectedRoute><ReportMembersEditor /></ProtectedRoute>} />
          <Route path="/groups-overview" element={<ProtectedRoute><GroupOverview /></ProtectedRoute>} />
          <Route path="/groups-edit" element={<ProtectedRoute><GroupsEdit /></ProtectedRoute>} />
          <Route path="/report-groups-edit" element={<ProtectedRoute><ReportGroupsEditor /></ProtectedRoute>} />
          <Route path="/reports-groups-assignment" element={<ProtectedRoute><ReportsGroupsAssignment /></ProtectedRoute>} />
          <Route path="/reports-overview" element={<ProtectedRoute><ReportOverview /></ProtectedRoute>} />
          <Route path="/button-report-definitions" element={<ProtectedRoute><ButtonReportDefinitionsEditor /></ProtectedRoute>} />
          <Route path="/logout" element={<Logout setAuth={setIsAuthenticated}/>} />
          {/* Table Routes */}
          {tables.map((t) => (
            <Route
              key={t}
              path={`/table/${encodeURIComponent(t)}`}
              element={<ProtectedRoute><TableAdmin table={t} /></ProtectedRoute>}
            />
          ))}
        </Routes>
      </div>
    </div>
  );
}
